import { required } from 'helpers/CommonValidations';
import isValid from 'date-fns/isValid';
import moment from 'moment';
import parse from 'date-fns/parse';

const validations = {
  grossMonthlyIncome: (state) => {
    return required('grossMonthlyIncome', state.grossMonthlyIncome);
  },
  primaryIncomeSource: (state) => {
    return required('primaryIncomeSource', state.primaryIncomeSource);
  },
  nameOfIncome: (state) => {
    return required('nameOfIncome', state.nameOfIncome);
  },
  occupation: (state) => {
    return required('occupation', state.occupation);
  },
  lengthOfReceivingIncome: (state) => {
    return required('lengthOfReceivingIncome', state.lengthOfReceivingIncome);
  },
  paymentFrequency: (state) => {
    return required('paymentFrequency', state.paymentFrequency);
  },
  date: (id, state, minDate, maxDate) => {
    if (!state[id]) {
      return required(id, state[id]);
    }
    const date = moment(state[id], 'MM/DD/YYYY');
    const dateForValidation = parse(state[id], 'MM/dd/yyyy', new Date());
    const isDateValid = isValid(dateForValidation);
    if (!isDateValid || state[id].length < 8) {
      return { [id]: 'Must be a valid date.' };
    }
    if (date.isBefore(minDate, 'day')) {
      return {
        [id]: `Date must be after ${moment(minDate)
          .subtract(1, 'day')
          .format('MM/DD/YYYY')}`
      };
    }
    if (date.isAfter(maxDate, 'day')) {
      return {
        [id]: `Date must be before ${moment(maxDate)
          .add(1, 'day')
          .format('MM/DD/YYYY')}`
      };
    }

    return { [id]: '' };
  },
  lastPayrollDate: (id, state, minDate, maxDate) => {
    return validations.date(id, state, minDate, maxDate);
  },
  nextPayrollDate: (id, state, minDate, maxDate) => {
    return validations.date(id, state, minDate, maxDate);
  },
  paymentType: (state) => {
    return required('paymentType', state.paymentType);
  },
  employmentStatus: (state) => {
    return required('employmentStatus', state.employmentStatus);
  },
  loanAmount: (state) => {
    if (
      state.loanAmount.length &&
      (parseInt(state.loanAmount, 10) > parseInt(state.maxLoanAmount, 10) ||
        parseInt(state.loanAmount, 10) < parseInt(state.minLoanAmount, 10))
    ) {
      return {
        loanAmount: `Please choose an amount between $${state.minLoanAmount} - $${state.maxLoanAmount}`
      };
    }
    return { loanAmount: null };
  }
};

export default validations;
